import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import AmazonButton from "@/components/AmazonButton";
import CategoryCard from "@/components/CategoryCard";
import BrandsSection from "@/components/BrandsSection";
import GenuineProductsSection from "@/components/GenuineProductsSection";
import { CATEGORIES } from "@/lib/site";

export default function Products() {
  return (
    <>
      <Seo
        title="Products | Wiper Blades, Spark Plugs and Filters | AutoNeova"
        description="AutoNeova offers wiper blades, spark plugs and ignition products, and oil, cabin air and engine air filters through its Amazon listings."
        path="/products"
      />
      <PageHeader
        testId="products-page-header"
        eyebrow="Products"
        title="Wiper blades, ignition products and filters"
        intro="AutoNeova offers a focused range of automotive replacement and maintenance products. This page describes our categories; ordering takes place on Amazon."
      />

      <section className="bg-white py-16 lg:py-24" data-testid="products-page-content">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {CATEGORIES.map((c, i) => (
              <CategoryCard key={c.slug} category={c} index={i} />
            ))}
          </div>

          <div className="mt-16 grid gap-10 rounded-lg bg-[#F4F6F8] p-8 lg:grid-cols-2 lg:p-12">
            <div>
              <h2 className="text-2xl font-extrabold text-[#0B1F33] md:text-3xl">
                Availability and product details
              </h2>
              <p className="mt-4 text-base leading-relaxed text-[#263238]">
                Product selection and availability may change. Categories listed here describe the
                types of products we work with rather than a fixed catalog.
              </p>
            </div>
            <div className="lg:border-l lg:border-[#0B1F33]/10 lg:pl-10">
              <p data-testid="amazon-info-statement" className="text-base leading-relaxed text-[#263238]">
                Current product availability, pricing, vehicle compatibility, technical information,
                delivery terms and customer reviews are available through the applicable Amazon
                product listings.
              </p>
              <AmazonButton testId="products-amazon-cta" className="mt-8">
                Shop Current Products on Amazon
              </AmazonButton>
            </div>
          </div>
        </div>
      </section>

      <BrandsSection background="light" />
      <GenuineProductsSection background="white" />
    </>
  );
}
